module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"list_appointment":"Appointments","AppointmentModalTitle":"Appointments"},"si":{"list_appointment":"හමුවීම් ලැයිස්තුව","AppointmentModalTitle":"හමුවීම්"},"ta":{"list_appointment":"நியமனங்கள்","AppointmentModalTitle":"sநியமனங்கள்"}}')
  delete Component.options._Ctor
}
